import React, { Component } from 'react';
//import { isSingleDomainPages } from '../../../utils/common';
import s from './AddOrgSchema.scss';

export default function AddOrgSchema(
  insertComponent,
  toipLayout,
  // isWapView = false,
  // pageCanonicalUrl = '',
) {
  return class extends Component {
    render() {
      return (
        <div
          itemType="https://schema.org/Organization"
          itemScope="itemscope"
          itemProp="publisher"
          className={toipLayout ? '' : s.snowwhite}
        >
          {insertComponent}
          <span
            itemType="https://schema.org/ImageObject"
            itemScope="itemscope"
            itemProp="logo"
          >
            <meta
              content="https://static.toiimg.com/photo/msid-58127550/toilogo.jpg"
              itemProp="url"
            />
            <meta content="600" itemProp="width" />
            <meta content="60" itemProp="height" />
          </span>
          <meta content="Times of India" itemProp="name" />
          <meta content="https://timesofindia.indiatimes.com" itemProp="url" />
          {/* {isWapView && !isSingleDomainPages(pageCanonicalUrl) ? (
            <meta content="https://m.timesofindia.com" itemProp="url" />
          ) : (
            <meta
              content="https://timesofindia.indiatimes.com"
              itemProp="url"
            />
          )} */}
        </div>
      );
    }
  };
}
